/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Settings_Logo_FormatsInputs */



/**
* | output |
* | --- |
* | "PNG, JPEG, WebP, or SVG. Max 1MB." |
*
* @param {Org_Settings_Logo_FormatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_settings_logo_formats = /** @type {((inputs?: Org_Settings_Logo_FormatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Settings_Logo_FormatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PNG, JPEG, WebP oder SVG. Max. 1 MB.")
	return /** @type {LocalizedString} */ ("PNG, JPEG, WebP, or SVG. Max 1MB.")
});